/**
 * Avisos del portal.
 *
 * Copy (§11): los errores dicen qué pasó y cómo seguir, sin disculparse; los
 * estados vacíos dicen qué hacer. Un aviso sin texto accionable no se muestra.
 */

import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';
import type { ReactNode } from 'react';

import type { Mensaje, TonoAviso } from './mensajes';

const ICONO = {
  ok: CheckCircle2,
  error: XCircle,
  atencion: AlertTriangle,
  info: Info,
} as const;

export interface PropsAviso {
  readonly tono: TonoAviso;
  readonly children: ReactNode;
}

export function Aviso({ tono, children }: PropsAviso): React.JSX.Element {
  const Icono = ICONO[tono];
  return (
    <div className={`aviso aviso--${tono}`} role={tono === 'error' ? 'alert' : 'status'}>
      <Icono className="aviso-icono" size={16} aria-hidden="true" />
      <div className="aviso-texto">{children}</div>
    </div>
  );
}

/** Pila de avisos. Vacía no ocupa lugar ni deja un hueco en el layout. */
export function Avisos({ mensajes }: { readonly mensajes: readonly Mensaje[] }): React.JSX.Element | null {
  if (mensajes.length === 0) return null;
  return (
    <div className="avisos">
      {mensajes.map((m) => (
        <Aviso key={m.id} tono={m.tono}>
          {m.texto}
        </Aviso>
      ))}
    </div>
  );
}
